import { useState } from "react";
import { haptic } from "@/lib/haptic";

export const useCardPressAnimationAndHaptic = (onClick?: () => void) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleCardClick = () => {
    setIsPressed(true);
    haptic.soft();

    setTimeout(() => {
      if (onClick) onClick();
      setIsPressed(false);
    }, 400);
  };

  return { isPressed, handleCardClick };
};
